import './MonthsDropDown.scss'
import Moment from 'moment'
import { useState } from 'react'
import { useEffect } from 'react'

const MonthsDropDown = ({ handleMonthClick, selectedDateProp }) => {
    const [showMonthsList, setShowMonthsList] = useState(false)
    const selectedMonth = Moment().locale('en').month(selectedDateProp.getMonth()).format('MMMM')
    const selectedYear = Moment().locale('en').year(selectedDateProp.getFullYear()).format('YYYY')
    const currentYear = Moment().locale('en').year(new Date().getFullYear()).format('YYYY')
    const months = []
    const monthsIndex = []
    let year = currentYear
    for (let i = new Date().getMonth(); i < new Date().getMonth() + 12; i++) {
        if (i % 12 === 0 && i !== 0) {
            year = Moment().add(1, 'years').format('YYYY')
        }
        if (i % 12 >= new Date().getMonth()) {
            months.push(Moment().month(i).format('MMMM') + ' ' + currentYear)
            monthsIndex.push(Moment().locale('en').month(i).format('MMMM') + ' ' + currentYear)
        } else {
            months.push(Moment().month(i).format('MMMM') + ' ' + year)
            monthsIndex.push(Moment().locale('en').month(i).format('MMMM') + ' ' + year)

        }

    }
    const overlay = showMonthsList ? 'dropDown-overlay' : ''
    const arrowDirection = showMonthsList ? 'up' : 'down'
    return (
        <div className={`dropdown-wrapper ${overlay}`}>
            {
                monthsIndex.map((month,index) => {
                    if (month === (selectedMonth + ' ' + selectedYear)) {
                        return (<div className={`dropdown-header ${arrowDirection}`} onClick={() => setShowMonthsList(!showMonthsList)}>
                            {months[index]}
                        </div>)
                    }
                })
            }
            {showMonthsList && <ul className='dropdown-body'>
                {
                    monthsIndex.map((month,index) => {
                        const selectedItem = (selectedMonth + ' ' + selectedYear === month) ? 'selected' : ' '
                        return (
                            <li className={`list-item ${selectedItem}`} key={month} onClick={() => {
                                handleMonthClick(month);
                                setShowMonthsList(!showMonthsList)
                            }
                            }>{months[index]}</li>
                        )
                    })
                }
            </ul>}
        </div>
    )
}

export default MonthsDropDown
